<template>
  <section>
    <span class="section-title">Work Experience</span>

    <ul class="experience-list">
      <li
        v-for="(job, index) in content.experience"
        :key="index"
        class="bulleted-item"
      >
        <div class="item-header">
          <div class="item-info">
            <span class="item-name">{{ job.role }}</span>
            <span class="item-subname">{{ job.company }}</span>
          </div>
          <span class="item-date">{{ job.duration }}</span>
        </div>
        <p v-if="job.description" class="item-detail">{{ job.description }}</p>
      </li>
    </ul>
  </section>
</template>

<script setup lang="ts">
import { content } from "@/content/data";
</script>
